// components/DoughnutChart.js
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

interface LineChartProps {
  data: any;
  options: any;
}

const DoughnutChart: React.FC<LineChartProps> = ({
  data,
  options,
}: LineChartProps) => {

  return <Doughnut data={data} options={options} />;
};

export default DoughnutChart;
